const reducer = (state, props) => {
    const { type, payload } = props || {};
    let orders;
    // console.log(type);
    switch (type) {
        case 'SET_STATE_DATA':
            return {
                ...state,
                ...payload,
            }

        case 'UPDATE_ORDER_NEW_TAB':
            orders = (payload.first > 0 ? state.orders : []).concat(payload.orders)
            if (state.activeTab !== 0) {
                return state;
            }
            return {
                ...state,
                ...payload,
                orders,
            }

        case 'SET_ORDERS':
            orders = (payload.first > 0 ? state.orders : []).concat(payload.orders)
            return {
                ...state,
                ...payload,
                orders,
            }

        case 'CLEAR_STATE':
            return {}

        case "LOADING":
            return {
                ...state,
                requireCheck: undefined,
                loading: true
            }
        case "LOADED":
            return {
                ...state,
                loading: false,
                message: payload
            }

        case 'SET_FIELD':
            return {
                ...state,
                [payload.name || 'ERROR_IN_FIELD_NAME']: {
                    ...(state[payload.name || 'ERROR_IN_FIELD_NAME'] || {}),
                    ...payload.part
                }
            }

        case "SUCCESS":
            return {
                ...state,
                message: payload,
                loading: false,
                requireCheck: null,
            }

        case 'LOAD_FAILED':
            return {
                ...state,
                loading: false,
                message: payload,
            }
        default:
            return state;

    }
}
export default reducer;
